/**
 * Conversas — chamadas REST específicas (T3, SPRINT-UI-REFOUNDATION-1).
 *
 * Renomear: `PATCH /api/v1/conversations/:id` (motor `src/api/v1/conversations/routes.ts:11`,
 * schema `title: z.string().min(1).max(200)`). O limite do produto é MENOR (120) e vale
 * no cliente: a sidebar não comporta mais que isso sem cortar.
 *
 * Precedência do nome manual sobre o automático: o motor NÃO tem `titleSource`; o
 * auto-título só roda no primeiro turno E quando o título ainda é o padrão
 * (`isDefaultConversationTitle`, handlers.ts:45-50, 282-292). Um nome renomeado nunca
 * casa com esse padrão, logo nunca é sobrescrito. Medido no develop a635793.
 */
import { z } from 'zod'
import { api } from '@/lib/api'

export const CONVERSATION_TITLE_MAX = 120

export const ConversationTitleSchema = z.string().trim().min(1).max(CONVERSATION_TITLE_MAX)

export async function renameConversationRequest(id: string, title: string): Promise<void> {
  await api.patch<{ data: unknown }>(`/api/v1/conversations/${id}`, { title })
}
